export const GET_PROVEEDORES_REQUEST = 'GET_PROVEEDORES_REQUEST';
export const GET_PROVEEDORES_SUCCESS = 'GET_PROVEEDORES_SUCCESS';
export const GET_PROVEEDORES_FAILURE = 'GET_PROVEEDORES_FAILURE';
export const RESET_PROVEEDORES = 'RESET_PROVEEDORES';
